export default (state = [], payload) => {
  switch (payload.type) {
    case "GET_VIEWS_AND_RESULTS_SUCCESS":
      let found = false;
      for (let v of state) if (v.sessionid === payload.data.sessionid) found = true;
      if (found) return updateViews(state, payload);
      else {
        state.push(payload.data);
        return state;
      }
      break;
    default:
      return state;
  }
};

function updateViews(state, payload) {
  return state.map((view) => {
    if (view.sessionid !== payload.data.sessionid) {
      return view;
    }
    return {
      ...view,
      views: payload.data.views,
      results: payload.data.results,
    };
  });
}
